/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProjectRequestResponseDto } from './projectRequestResponseDto.model';
import { CreateProjectDefaultDto } from './createProjectDefaultDto.model';
import { CreateProjectActualizationDto } from './createProjectActualizationDto.model';
import { ProjectOptionRequestDto } from './projectOptionRequestDto.model';


export interface ProjectRequestDto { 
    allowActualization: boolean;
    allowLiquibase?: boolean;
    blockUsers?: boolean;
    customerId: number;
    key: string;
    name?: string;
    projectActualization: CreateProjectActualizationDto;
    projectDefault: CreateProjectDefaultDto;
    projectOption: ProjectOptionRequestDto;
    projectRequest: ProjectRequestResponseDto;
}

